const selectObject = <T extends Record<string, unknown>>(obj: T, keys: (keyof T)[]): Partial<T> =>
  keys.reduce((acc, key) => ({ ...acc, [key]: obj[key] }), {});

export default selectObject;
